module.exports = __webpack_public_path__ + "static/media/witness.e16aaa34.svg";